export const environment = {
  production: true,
  name: 'production',
  apiServer: "https://pnwnvb64o6.execute-api.eu-west-2.amazonaws.com/1",
  clientToken: "7528725qk56184346126321324vz5bizsxv6zc3ul5ytfjriyykci3p1ptti09th",
};
